import { Component, inject, Input, Output } from "@angular/core";
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { PictureCardComponent } from "@components/picture-card/picture-card.component";
import { DeviceType } from "@domain/product/monitoring/device";
import { ProductImage } from "@domain/product/product-image";
import { defer, filter, map, of } from "rxjs";

export class KvmCategory {
  constructor(
    public readonly deviceType: DeviceType,
    public readonly imageId?: string,
  ) {}
}

@Component({
  selector: "app-kvm-category-selection",
  templateUrl: "./kvm-category-selection.component.html",
  styleUrls: ["./kvm-category-selection.component.scss"],
  imports: [UiKitModule, ReactiveFormsModule, PictureCardComponent],
  standalone: true,
})
export class KvmCategorySelectionComponent {
  private formBuilder = inject(FormBuilder);

  protected readonly categories: KvmCategory[] = [
    new KvmCategory(DeviceType.KVM_T_P2P, ProductImage.getCantoSourceUrl(`2tsbegg0qt34f3sbk1l11lh75f`)),
    new KvmCategory(DeviceType.KVM_T_IP, ProductImage.getCantoSourceUrl(`dsi91qsgvt5l9fkc7g8s508u1m`)),
  ];

  @Input() set originalDeviceType(deviceType: DeviceType | undefined) {
    if (deviceType) {
      this.categoryForm.patchValue({ selectedCategory: deviceType });
    }
  }

  protected categoryForm = this.formBuilder.group({
    selectedCategory: new FormControl<null | DeviceType>(null, Validators.required),
  });

  @Output()
  formReady = of(this.categoryForm);

  @Output()
  categorySelected = defer(() =>
    this.categoryForm.valueChanges.pipe(
      filter((formValue) => !!formValue.selectedCategory),
      map((formValue) => formValue.selectedCategory!),
    ),
  );

  protected onCategoryClicked(category: KvmCategory) {
    this.categoryForm.patchValue({ selectedCategory: category.deviceType });
  }

  protected getCategoryLabel(deviceType: DeviceType) {
    switch (deviceType) {
      case DeviceType.KVM_T_P2P:
        return $localize`:@@kvmConfiguration.category.p2p:P2P`;
      case DeviceType.KVM_T_IP:
      default:
        return $localize`:@@kvmConfiguration.category.overIp:Over IP`;
    }
  }
}
